<template>
    <div></div>
</template>

<script>
export default {
    metaInfo: {
        title: ""
    },

    components: {},

    mounted() {
        this.check_session();
    },

    props: {
        is_pre2fa_route: {
            type: Boolean,
            default: false
        }
    },

    data: function() {
        return {};
    },

    watch: {},

    computed: {},

    methods: {
        check_session: function() {
			let check_session_endpoint = "user/CheckSession";
            if (this.is_pre2fa_route) {
                check_session_endpoint = "user/Pre2FACheckSession";
            }

            let self = this;
            this.$store.dispatch(check_session_endpoint).then(
                (success_data) => {
                    // If the User is already logged
					this.$store.commit('user/setCheckSessionExecuted');

                    if (this.$store.state.routes_to_avoid_check_session.indexOf(this.$route.name) !== -1) {
                        window.location.href = "/ui/domains";
                    }
                },
                (error_data) => {
                	this.$store.commit('user/setCheckSessionExecuted');

					console.error("Session check failure");
                    if (this.$store.state.routes_to_avoid_check_session.indexOf(this.$route.name) !== -1) {
                        // Do nothing, user is not logged in, perhaps we is trying to login or change pass etc
                        // window.location.href = "/ui/login";
                    }
                    else
                    {
                        // User should probably not be allow, so let's redirect him
                        window.location.href = this.$root.$children[0].loginPageUrl(window.location.href);
                    }
                }
            );
        }
    }
};
</script>
